class BESSAppProjectProfilersManager extends BESSAppBase {

    constructor() {
        super();
        if (typeof BESSProfilersData === 'undefined') {
            this.profilers = [];
            return;
        }
        this.profilers = _.map(BESSProfilersData, data => new BESSAppProjectProfiler(data));
        this.subscribeToEvents(BESSAppProjectEditorSavedEvent.name, this.#onEditorSaved);
    }

    managerFor(editorId) {

    }

    start() {
        this.log('Loaded', this);
        this.forEach(this.profilers, (x) => x.start());
    }

    #onEditorSaved(event) {
        this.log("#onEditorSaved", event);
        this.forEach(event.profilers, this.updateProfiler);
        this.fireEvent(new BESSAppProjectProfilersUpdatedEvent());
    }

    updateProfiler(profilerData) {
        let profiler = this.getProfiler(profilerData.editorId);
        if(profiler !== undefined) {
            profiler.update(profilerData);
        }
    }

    replaceProfiler(profilerData) {
        _.remove(this.profilers, (profiler) => profiler.identifier === profilerData.editorId);
        let newProfiler = new BESSAppProjectProfiler(profilerData);
        this.profilers.push(newProfiler);
        newProfiler.start();
    }

    getProfiler(identifier) {
        return _.find(this.profilers, (profiler) => profiler.identifier === identifier);
    }
}